// Trim whitespace to prevent invalid App ID errors
export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID?.trim();

export const AGORA_APP_CERTIFICATE =
  process.env.REACT_APP_AGORA_APP_CERTIFICATE?.trim();

export const COFFEE_CALL_DUMMY_CHANNEL = "123456";

export const REACT_APP_NOTIFICATION_VAPID_KEY =
  process.env.REACT_APP_NOTIFICATION_VAPID_KEY;

// Trim whitespace to prevent invalid App ID errors
export const AGORA_RTM_APP_ID =
  process.env.REACT_APP_AGORA_RTM_APP_ID?.trim() as string;
export const REACT_APP_API_BASE_URL = process.env
  .REACT_APP_API_BASE_URL as string;

// Google OAuth Client ID for "Connect YouTube Account" (youtube.force-ssl scope)
export const REACT_APP_GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim();

// Zego Cloud Configuration
export const ZEGO_APP_ID = process.env.REACT_APP_ZEGOCLOUD_APP_ID;
export const ZEGO_APP_SIGN =
  process.env.REACT_APP_ZEGO_APP_SIGN || "YOUR_APP_SIGN";
export const ZEGO_SERVER_ENV =
  process.env.REACT_APP_ZEGO_SERVER_ENV === "true" || true;
export const ZEGOCLOUD_ROOM_URL =
  process.env.REACT_APP_ZEGOCLOUD_ROOM_URL || "";
